/* Amalife — client-side search over title + SKU + ingredients (amalife.composition
   + amalife.ingredients). Supplements Wonder's native predictive dropdown and the
   /search results page with matches the native index misses (ingredient/SKU terms).
   Index is served by sections/ama-search-index.liquid via the Section Rendering API. */
(function () {
  'use strict';

  var INDEX = null;
  var INDEX_PROMISE = null;

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (INDEX_PROMISE) return INDEX_PROMISE;
    try {
      var cached = sessionStorage.getItem('amaSearchIndex');
      if (cached) { INDEX = JSON.parse(cached); return Promise.resolve(INDEX); }
    } catch (e) {}
    INDEX_PROMISE = fetch('/?section_id=ama-search-index')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var el = doc.getElementById('ama-search-index-data');
        INDEX = el ? JSON.parse(el.textContent) : [];
        try { sessionStorage.setItem('amaSearchIndex', JSON.stringify(INDEX)); } catch (e) {}
        return INDEX;
      })
      .catch(function () { INDEX = []; return INDEX; });
    return INDEX_PROMISE;
  }

  function norm(s) { return (s || '').toString().toLowerCase().trim(); }

  /* Bulgarian shoppers routinely spell the letter out: "витамин Ц" for the
     product labelled "Витамин С". A blanket ц->с fold would wreck ordinary words
     (цена vs сена), so only these exact phrases are rewritten, and only in the
     query — never in the product titles being matched against.

     Note: JavaScript word boundaries are ASCII-only, so anchoring a Cyrillic
     word with them never matches at all. The guard is a lookahead for a
     following letter instead, which keeps "витамин цена" from being rewritten. */
  var QUERY_ALIASES = [
    [/витамин\s*це(?![а-я])/g, 'витамин с'],
    [/витамин\s*ц(?![а-я])/g, 'витамин с'],
    [/vitamin\s*c(?![a-z])/g, 'витамин с']
  ];
  function normQuery(q) {
    var s = norm(q);
    for (var i = 0; i < QUERY_ALIASES.length; i++) {
      s = s.replace(QUERY_ALIASES[i][0], QUERY_ALIASES[i][1]);
    }
    return s;
  }

  /* Where the query landed decides the order: a product whose NAME matches must
     outrank one that merely mentions the words in its description or ingredient
     list. Lower is better. The same scale is applied to Shopify's own dropdown
     rows, so both lists sort by one rule.
       0  name starts with the whole query
       1  name contains the whole query
       2  every word of the query is somewhere in the name
       3  SKU match
       4-5 only some words are in the name (more words matched = higher up)
       6  nothing in the name — matched the description, ingredients or vendor */
  function rankTitle(title, nq, toks) {
    var t = norm(title || '');
    if (!t) return 6;
    if (t.indexOf(nq) === 0) return 0;
    if (t.indexOf(nq) !== -1) return 1;
    var hit = 0;
    for (var i = 0; i < toks.length; i++) {
      if (t.indexOf(toks[i]) !== -1) hit++;
    }
    if (hit === toks.length) return 2;
    if (hit > 0) return 5 - hit / toks.length;
    return 6;
  }

  function matchRanked(q, limit) {
    var nq = normQuery(q);
    if (nq.length < 2 || !INDEX) return [];
    var toks = nq.split(/\s+/).filter(Boolean);
    var out = [];
    for (var i = 0; i < INDEX.length; i++) {
      var it = INDEX[i], kw = it.kw || '', ok = true;
      for (var j = 0; j < toks.length; j++) {
        if (kw.indexOf(toks[j]) === -1) { ok = false; break; }
      }
      if (!ok) continue;
      var rank = rankTitle(it.t, nq, toks);
      var sku = norm(it.s);
      if (rank > 3 && sku && sku.indexOf(nq) !== -1) rank = 3;
      out.push({ it: it, rank: rank, i: i });
    }
    out.sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });
    return out.slice(0, limit || 6);
  }

  function match(q, limit) {
    return matchRanked(q, limit).map(function (x) { return x.it; });
  }

  /* Shopify's predictive search treats every hit as equal, so a product that
     merely mentions the words ranked alongside one actually named that. Re-sort
     its rows by rankTitle. The <li> nodes are moved, never rebuilt, so images,
     prices and links stay exactly as the theme rendered them. */
  function reorderNative(container, q) {
    var list = container && container.querySelector('#predictive-search-results-list');
    if (!list) return;
    var nq = normQuery(q);
    var toks = nq.split(/\s+/).filter(Boolean);
    if (!toks.length) return;
    var items = [];
    Array.prototype.forEach.call(list.children, function (li, i) {
      if (!li.querySelector('a[href*="/products/"]')) return;
      var h = li.querySelector('.predictive-search__item-heading');
      items.push({ li: li, r: rankTitle(h ? h.textContent : '', nq, toks), i: i });
    });
    if (items.length < 2) return;
    items.sort(function (a, b) { return a.r - b.r || a.i - b.i; });
    items.forEach(function (x) { list.appendChild(x.li); });
  }

  function esc(s) {
    return (s || '').toString().replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function rowHtml(it) {
    var img = it.img
      ? '<img class="ama-sres__img" src="' + esc(it.img) + '" alt="" loading="lazy" width="44" height="44">'
      : '<span class="ama-sres__img ama-sres__img--ph"></span>';
    return '<li class="ama-sres__item"><a class="ama-sres__link" href="' + esc(it.u) + '">' + img +
      '<span class="ama-sres__body">' +
      (it.vn ? '<span class="ama-sres__vendor">' + esc(it.vn) + '</span>' : '') +
      '<span class="ama-sres__title">' + esc(it.t) + '</span>' +
      (it.pr ? '<span class="ama-sres__price">' + esc(it.pr) + '</span>' : '') +
      '</span></a></li>';
  }

  function existingHandles(root) {
    var map = {};
    if (!root) return map;
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
      if (m) map[decodeURIComponent(m[1])] = 1;
    });
    return map;
  }

  /* ---- Header predictive dropdown ---------------------------------------- */
  function supplementDropdown(container, q) {
    if (!container) return;
    loadIndex().then(function () {
      var drawer = container.closest('search-drawer');
      var input = drawer && drawer.querySelector('input[name="q"]');
      if (input && norm(input.value) !== norm(q)) return; // stale response
      container.querySelectorAll('.ama-sres').forEach(function (n) { n.remove(); });
      reorderNative(container, q);
      var matches = match(q, 6);
      if (!matches.length) return;
      var have = existingHandles(container);
      var fresh = matches.filter(function (it) { return !have[it.h]; });
      if (!fresh.length) return;
      // when native found no products, hide its "no results" message + styling
      var nativeProducts = container.querySelectorAll('#predictive-search-results-list a[href*="/products/"]').length;
      if (nativeProducts === 0) {
        var noResDiv = container.querySelector('.search-result--no-results');
        if (noResDiv) noResDiv.classList.remove('search-result--no-results');
        var noResText = container.querySelector('[data-predictive-search-live-region-count-value]');
        if (noResText) noResText.style.display = 'none';
      }
      /* When the theme itself found nothing, this block IS the product list —
         calling it "по състав и описание" would mislabel rows that match the
         product name perfectly well. */
      var heading = nativeProducts === 0 ? 'Продукти' : 'По състав и описание';
      var wrap = document.createElement('div');
      wrap.className = 'ama-sres ama-sres--drawer';
      wrap.innerHTML =
        '<div class="ama-sres__head">' + heading + '</div>' +
        '<ul class="ama-sres__list">' + fresh.map(rowHtml).join('') + '</ul>';
      /* Below the native list, not above it. The theme searches product names
         (include_title) but not descriptions (include_body is off), so anything
         only this index finds was matched in the composition or the ingredients
         — it must never outrank a product actually named that. */
      var products = container.querySelector('#predictive-search-results');
      if (products && products.parentNode) {
        products.parentNode.insertBefore(wrap, products.nextSibling);
      } else {
        container.appendChild(wrap);
      }
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('search-drawer').then(function () {
      var C = customElements.get('search-drawer');
      if (!C || C.prototype.__amaPatched) return;
      C.prototype.__amaPatched = true;
      var orig = C.prototype.renderSearchResults;
      C.prototype.renderSearchResults = function (markup) {
        orig.call(this, markup);
        try { supplementDropdown(this.predictiveSearchResults, this.getQuery()); } catch (e) {}
      };
    });
  }

  /* ---- /search results page --------------------------------------------- */
  function supplementResultsPage() {
    if (!/\/search\b/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || norm(q).length < 2) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    loadIndex().then(function () {
      var matches = match(q, 48);
      if (!matches.length) return;
      var have = existingHandles(grid);
      var fresh = matches.filter(function (it) { return !have[it.h]; });
      if (!fresh.length) return;
      // Suppress the products-tab "no products found" message (the wrapper varies and
      // may be (re)rendered async by the tab JS). A body class + CSS rule scoped to the
      // products container hides it whenever it appears, without touching other tabs.
      document.body.classList.add('ama-search-supplemented');
      // the native "0 резултата" counter contradicts the products we're adding — hide it
      // when the standard search itself returned none.
      var counter = document.querySelector('#ProductGridContainer .collection__counter');
      if (counter && /(^|\D)0(\D|$)/.test(counter.textContent)) counter.style.display = 'none';
      var block = document.createElement('div');
      block.className = 'ama-sres ama-sres--page';
      block.innerHTML =
        '<div class="ama-sres__head">Още резултати по състав и код (SKU)</div>' +
        '<ul class="ama-sres__list ama-sres__list--grid">' + fresh.map(rowHtml).join('') + '</ul>';
      /* after the grid, for the same reason as the dropdown: these were matched
         in the composition or the SKU, not in the product name */
      grid.parentNode.insertBefore(block, grid.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', supplementResultsPage);
  } else {
    supplementResultsPage();
  }
})();
